<template>
  <div class="socs">
    <a
      v-for="item in links"
      :key="item.title"
      v-bind="item"
      v-html="require(`@/assets/img/${item.title}-green.svg`)"
    />
  </div>
</template>

<script>
export default {
  name: 'SocialLinks',
  data: () => ({
    links: [
      { href: 'https://vk.com/bimlib', target: '_blank', title: 'vk' },
      { href: 'https://t.me/bimlib_pro', target: '_blank', title: 'telegram' },
      { href: 'https://www.youtube.com/channel/UCIVQgYmqw8cXDJlDd_2S_6w', target: '_blank', title: 'youtube' },
      { href: 'https://dzen.ru/bimlib', target: '_blank', title: 'dzen' },
    ]
  })
}
</script>

<style lang="scss" scoped>
.socs {
  display: flex;
  align-items: center;

  a + a {
    margin-left: 10px;
  }
}
</style>
